import React from "react";

// components
import ODHeader from "../components/offering-details/ODHeader";
import ODTable from "../components/offering-details/ODTable";
import ShareClassFees from "../components/offering-details/ShareClassFees";
import AdvisorFees from "../components/offering-details/AdvisorFees";
import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const OfferingDetails = () => {
  return (
    <>
      <ODHeader />
      <ODTable />
      <ShareClassFees />
      <AdvisorFees />
      <PrePreFooter>
        <ol className="list-decimal">
          <li className="text-base">
            Terms summarized herein are for informational purposes and qualified
            in their entirety by the more detailed information set forth in the
            StratCap Digital Infrastructure REIT, Inc. (“DIR”) prospectus. You
            should read the prospectus carefully prior to making an investment.
          </li>
          <li className="text-base">
            The offering price is equal to the transaction price, which
            generally equals the prior month’s NAV, plus applicable selling
            commissions and dealer manager fees. We expect that we will make
            each monthly NAV per share publicly available by posting it on our
            website and filing a prospectus supplement with the SEC
            approximately 15 calendar days following the last calendar day of
            each month. Completed subscription requests will not be accepted by
            DIR before the later of (i) two business days before the first
            calendar day of each month and (ii) five business days after we make
            the transaction price (including any transaction price subsequently
            revised in certain circumstances) publicly available by posting it
            on our website and filing a prospectus supplement with the SEC. DIR
            may offer shares at a price that it believes reflects the NAV per
            share of such stock more appropriately than the prior month’s NAV
            per share, including by updating a previously disclosed transaction
            price, in cases where DIR believes there has been a material change
            to the NAV per share since the end of the prior month.
          </li>
          <li className="text-base">
            The availability and timing of distributions DIR may pay is
            uncertain and cannot be assured. Distributions have historically
            exceeded earnings. If DIR pays distributions from sources other than
            cash flow from operations, DIR will have less funds available for
            the acquisition of properties, and stockholder’s overall return may
            be reduced.
          </li>
          <li className="text-base">
            On a monthly basis, stockholders may request that we repurchase all
            or any portion of their shares. Repurchases are discretionary and
            will generally be limited to no more than 1.67% of our aggregate NAV
            per month and no more than 5% of our aggregate NAV per calendar
            quarter. Shares that have not been outstanding for at least one year
            will be subject to an “Early Repurchase Deduction” and repurchased
            at 95% of the transaction price. The DIR board of directors may
            suspend or amend the share repurchase program without stockholder
            approval; stockholders may not be able to repurchase their shares.
            The share repurchase program is subject to additional terms and
            limitations as described in the prospectus. Subject to the
            limitations and restrictions of the share repurchase program,
            stockholders may request that DIR redeem their shares on a
            continuous basis, but DIR is not obligated to redeem any shares and
            may choose to redeem only some, or even none, of the shares that
            have been requested to be redeemed in any particular month at DIR’s
            discretion. Further, while DIR may consider a liquidity event at any
            time in the future, DIR currently does not have a fixed time frame
            in which it intends to undertake such consideration and DIR is not
            obligated by its charter or otherwise to affect a liquidity event at
            any time.
          </li>
          <li className="text-base">
            Restrictions apply, please refer to the section of the prospectus
            titled “Share Repurchase Program” for complete details. DIR shares
            should be considered as having only limited liquidity and at times
            may be illiquid.
          </li>
          <li className="text-base">
            We will cease paying the stockholder servicing fee with respect to
            any Class D share, Class S share and Class T share held in a
            stockholder’s account at the end of the month in which the dealer
            manager in conjunction with the transfer agent determines that total
            stockholder servicing fees paid with respect to the shares held by
            such stockholder within such account would exceed, in the aggregate,
            8.75% of the gross proceeds from the sale of such shares (which for
            any shares issued as deemed distributions will be deemed to be the
            full, non-discounted offering price of such shares at the time of
            issuance). At the end of such month, each such share (including any
            fractional share) will convert into a number of Class I shares with
            an equivalent aggregate NAV as such share. Although we cannot
            predict the length of time over which the stockholder servicing fee
            will be paid due to potential changes in the NAV of our stock, this
            fee would be paid with respect to a Class T share (in the case of a
            limit of 8.75% of gross proceeds) or Class S share over
            approximately 7 years from the date of purchase and with respect to
            a Class D share over approximately 30 years from the date of
            purchase, assuming payment of the full upfront selling commissions
            and dealer manager fees, opting out of the distribution reinvestment
            plan and a constant NAV of $10.00 per share. Select broker-dealers
            may have different standards to determine the appropriateness of
            this investment for each investor and may not offer all share
            classes.
          </li>
          <li className="text-base">
            Excludes (1) NAV attributable to certain interests (“OP Units”) in
            DIR Operating Partnership, L.P., our operating partnership, that
            were sold in a private offering and (2) a separate management fee
            payable with respect to such OP Units.
          </li>
        </ol>
      </PrePreFooter>
      <PreFooter />
      <Footer />
    </>
  );
};

export default OfferingDetails;
